import React from "react";
import Footer from "../components/Footer";
import FadeInSection from "../components/FadeInSection";
import TechNavbar from "../components/TechNavbar";
import MainHeor from "../components/AboutUs/MainHero";
import Amini from "../assets/amini.jpg";
import FeaturedServices from "../components/AboutUs/OurServices";
import TrustedPartners from "../components/AboutUs/TrustedPartners";
import AboutYth from "../components/AboutUs/AboutYth";
import AboutYarqinMirzad from "../components/AboutUs/AboutYarqinMirzad";
import PageBanner from "../components/AboutUs/PageBanner";
import ItParkPartnership from "../components/AboutUs/ItParkPartnership";
import ItParkGallery from "../components/AboutUs/ItParkGallery";
import RolesAndActivities from "../components/AboutUs/RolesAndActivities";

const About = () => {
  return (
    <div className="min-h-screen bg-white font-sans">
      {/* <Header /> */}
      <TechNavbar />

      <FadeInSection>
        <MainHeor />
      </FadeInSection>

      <FadeInSection>
        <AboutYth />
      </FadeInSection>

      <FadeInSection>
        <AboutYarqinMirzad />
      </FadeInSection>

      <FadeInSection>
        <PageBanner />
      </FadeInSection>

      <FadeInSection>
        <ItParkPartnership />
      </FadeInSection>
      {/* ///////////////// */}

      {/* <!-- Photo Gallery Section --> */}

      <FadeInSection>
        <ItParkGallery />
      </FadeInSection>
      {/* /////////////////////// */}

      {/* ///////  ROLES AND ACTIVITIES //////// */}

      <FadeInSection>
        <RolesAndActivities />
      </FadeInSection>

      {/* ////////////////////////////// */}

      {/* MINI OUR SERVICES SECTION */}
      <FadeInSection>
        <FeaturedServices />
      </FadeInSection>

      {/* TRUSTED BY COMPANIES SECTION */}
      <FadeInSection>
        <TrustedPartners />
      </FadeInSection>

      <Footer />
    </div>
  );
};

export default About;
